export async function generateNewCardNumber(officeId, isCgs, inputId) {
    const cardNumber = await window.user.generateCardNumber(officeId, isCgs);
    const input = document.getElementById(inputId);
    if (input) {
        input.value = cardNumber;
    }
}
